<div class="chat-overlay-host">
  <div
    class="lobby-log-frame"
    [style.max-height]="
      mobile.isMobile && mobile.isZoomed ? 'calc(100vh - 300px)' : 'unset'
    "
  >
    @if (!mobile.isMobile) {
      <div class="log-tabs">
        @for (tab of tabs; track tab.id) {
          <button
            #logTab
            type="button"
            class="log-tab"
            [class.active]="activeLobbyTab() === tab.id"
            (click)="setActiveLobbyTab(tab.id)"
          >
            {{ tab.label }}
          </button>
        }
        <span class="log-tab-indicator" #tabIndicator></span>
      </div>
    }

    <div class="log-snap-wrap">
      <div class="log-snap" #snapContainer (scroll)="onSnapScroll($event)">
        <div class="log-panel" autoScroll>
          @for (msg of chat.lobbyLogMessages(); track msg.id) {
            <div class="lobby-log-row">
              <app-lobby-feed-event [msg]="msg" [completedBattleKeys]="completedBattleKeys()" [nowMs]="nowMs()"></app-lobby-feed-event>
            </div>
          }
        </div>
        <div class="log-panel" autoScroll>
          @for (msg of gameEventsLog(); track msg.id ?? msg) {
            <div class="lobby-log-row">
              <app-lobby-feed-event [msg]="msg" [completedBattleKeys]="completedBattleKeys()" [nowMs]="nowMs()"></app-lobby-feed-event>
            </div>
          }
        </div>
        <div class="log-panel" autoScroll>
          @for (msg of chatOnlyLog(); track msg.id ?? msg) {
            <div class="lobby-log-row">
              <app-lobby-feed-event [msg]="msg" [completedBattleKeys]="completedBattleKeys()" [nowMs]="nowMs()"></app-lobby-feed-event>
            </div>
          }
        </div>
      </div>
    </div>

    @if (mobile.isMobile) {
      <div class="log-dots">
        @for (tab of tabs; track tab.id) {
          <button type="button" class="log-dot" [attr.aria-label]="tab.label"
            [class.on]="activeLobbyTab() === tab.id" (click)="setActiveLobbyTab(tab.id)"></button>
        }
      </div>
    }
  </div>

  <div class="chat-input-form">
    <app-chat-input-row
      placeholder="Write a message"
      (send)="sendLobbyChatMessage($event)"
    />
  </div>

  @if (hasTeam() === false) {
    @if (migration.suppressSetup()) {
      <div
        class="chat-team-setup-overlay"
        role="region"
        aria-label="Account restore"
      >
        @if (migration.status() === 'failed') {
          <div class="chat-team-setup-panel chat-team-setup-panel--alert">
            <span class="chat-team-setup-title chat-team-setup-title--alert"
              >RESTORE FAILED</span
            >
            <p class="chat-team-setup-msg">
              We couldn't bring your account over. Please try again.
            </p>
            <button
              type="button"
              class="modal-btn"
              (click)="migration.retry()"
            >
              Retry
            </button>
          </div>
        } @else {
          <div class="chat-team-setup-panel">
            <span class="chat-team-setup-title">RESTORING ACCOUNT</span>
            <p class="chat-team-setup-msg">Bringing your monsters over…</p>
            <span class="restore-spinner" aria-hidden="true"></span>
          </div>
        }
      </div>
    } @else if (
      !challenge.matchmakerApprovalPending() &&
      !challenge.needsMatchmakerApproval()
    ) {
      <div class="chat-team-setup-overlay" role="region" aria-label="Team setup">
        <div class="chat-team-setup-panel">
          <span class="chat-team-setup-title">GET STARTED</span>
          <app-team-setup-cta
            (openOnboarding)="openOnboarding.emit()"
          ></app-team-setup-cta>
        </div>
      </div>
    }
  }
</div>
